import styled from 'styled-components6';
import { SourceIcon } from '../SourceIcon';
import {
    Caption2,
    Subtitle2,
    ThemeBreakpoint,
    mqDown,
    mqUp,
} from '../../theme';
import { HTMLProps } from 'react';
import { When } from 'react-if';
import { Model } from 'rwl-shared';
import { Star, StarEmpty, StarHalf } from '../ReviewStars/ReviewStars';

export interface ReviewTotalBoxProps {
    count: number;
    rating: number;
    breakpoint?: ThemeBreakpoint;
    source?: Model.ContentSource | ('GMB' | 'Facebook');
}

const Container = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: fit-content;
`;

const SIZE = '12px';

const RatingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const StarContainer = styled.span<{ $breakpoint?: ThemeBreakpoint }>`
    flex-direction: row;
    justify-content: center;
    display: flex;
    margin: 0 8px;

    ${({ $breakpoint }) => `${$breakpoint && mqDown($breakpoint)} {
        display: none;
    }`}
`;
const SmallStarContainer = styled.span<{ $breakpoint?: ThemeBreakpoint }>`
    flex-direction: row;
    justify-content: center;
    display: flex;
    margin-left: 8px;

    ${({ $breakpoint }) => `${$breakpoint && mqUp($breakpoint)} {
        display: none;
    }`}
`;

const RatingNumber = styled(Subtitle2)`
    text-align: center;
    align-self: center;
`;

const ReviewCount = styled(Caption2)`
    color: #00000099;
    text-decoration: underline;
`;

export const ReviewTotalBox = ({
    source,
    rating,
    breakpoint,
    count,
    ...rest
}: ReviewTotalBoxProps &
    Omit<HTMLProps<HTMLDivElement>, 'children' | 'ref' | 'as'>) => {
    const renderStars = () => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            if (rating >= i) {
                stars.push(<Star key={i} />);
            } else if (rating >= i - 0.5) {
                stars.push(<StarHalf key={i} />);
            } else {
                stars.push(<StarEmpty key={i} />);
            }
        }
        return stars;
    };
    if (count === 0) {
        return null;
    }
    return (
        <Container {...rest} className={'reviewTotal_' + source}>
            <RatingWrapper>
                <SourceIcon
                    source={source}
                    style={{
                        width:
                            source === 'Internal'
                                ? `calc(${SIZE} * 2)`
                                : `calc(${SIZE} * 1.5)`,
                        height:
                            source === 'Internal'
                                ? `calc(${SIZE} * 2)`
                                : `calc(${SIZE} * 1.5)`,
                    }}
                />
                <StarContainer $breakpoint={breakpoint}>
                    {renderStars()}
                </StarContainer>{' '}
                <When condition={breakpoint !== undefined}>
                    <SmallStarContainer $breakpoint={breakpoint}>
                        <Star />
                    </SmallStarContainer>
                </When>
                <RatingNumber>{rating?.toFixed(1)}</RatingNumber>
            </RatingWrapper>
            <ReviewCount>{count} reviews</ReviewCount>
        </Container>
    );
};
